import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const setChangeHeader = () => {

  const hero = document.querySelector('.section-hero');
  const body = document.querySelector('body');

  if (!hero || !body) return;

  ScrollTrigger.create({
    trigger: hero,
    markers: false,
    start: "bottom top",
    onEnter: () => body.classList.add("is-change"),
    onLeaveBack: () => body.classList.remove("is-change"),
  });

}

export default setChangeHeader;